"use client";

import React, { useState } from "react";
import Image from "next/image";
import { TheContent } from "@/helpers/utils";

export default function Empresa({ data }) {
  const [selectedImage, setSelectedImage] = useState(null);

  const banner = data?.contentAttachments1?.map(item => {
    const hasImage = item?.attachFiles?.mediaCdnUrl || null;
    if(hasImage) {
      return {
        src: hasImage,
        title: item?.attachField1 || '',
        description: item?.attachField2 || ''
      }
    }

    return false;
  }).filter(f => f !== false)[0] || [];

  const galeria = data?.contentAttachments1?.map(item => {
    const hasImage = item?.attachFiles?.mediaCdnUrl || null;
    if(hasImage) {
      return {
        src: hasImage,
        title: item?.attachField1 || ''
      }
    }

    return false;
  }).filter(f => f !== false) || [];

  return (
    <div className="w-full min-h-screen bg-gray-50">
      {/* Banner principal */}
      <section className="relative w-full h-[400px] md:h-[700px] overflow-hidden">
        <Image
          src={ banner.src }
          alt={ banner.title }
          fill
          priority
          className="object-cover object-center"
        />
        <div className="absolute inset-0 bg-blue-900/60 flex items-center justify-center">
          { banner.title  && (
            <h1 className="text-white text-[32px] md:text-[48px] font-bold text-center px-4">
              { banner.title }
            </h1>
          )}

          { banner.description && (
            <div className="text-white text-[16px] sm:text-[18px] md:text-[20px] leading-snug">
              { banner.description }
            </div>
          )}
        </div>
      </section>

      {/* Seção de logo centralizado */}
      <section className="w-full py-12 bg-white">
        <div className="max-w-[1440px] mx-auto flex justify-center">
          <Image
            src="/assets/logos1.png"
            alt="Logo LG Centro Contábil"
            width={500}
            height={200}
            className="object-contain"
          />
        </div>
      </section>

      {/* Seção sobre a empresa */}
      <section className="w-full py-16 px-4">
        <div className="max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          {/* Coluna Esquerda */}
          <div className="flex flex-col relative">
            {/* Retângulo azul estilizado */}
            <div className="w-[100px] h-[8px] bg-blue-700 mb-6"></div>
            <h2 className="text-blue-700 text-[36px] md:text-[50px] font-semibold leading-tight">
              { data?.contentField1 }
            </h2>
          </div>

          {/* Coluna Direita */}
          <div className="flex flex-col gap-8 text-blue-700">
            { TheContent(data?.contentEditor1) }
          </div>
        </div>
      </section>

      {/* Galeria de imagens com fundo azul */}
      <section className="relative w-full py-20 px-4">
        {/* Retângulo azul atrás */}
        <div className="absolute inset-0 top-1/2 transform -translate-y-1/2 bg-blue-700 h-[200px] w-full z-0"></div>

        <div className="relative z-10 max-w-[1440px] mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-items-center">
          {galeria.map((item, i) => (
            <div
              key={i}
              className="max-w-[400px] w-full overflow-hidden rounded-2xl shadow-lg bg-white cursor-pointer hover:scale-[1.02] transition-transform duration-300"
              onClick={() => setSelectedImage(item.src )}
            >
              <Image
                src={ item.src }
                alt={ item.title }
                width={400}
                height={250}
                className="object-cover w-full h-[250px]"
              />
            </div>
          ))}
        </div>
      </section>

      {/* Modal de imagem ampliada */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-[90%] max-h-[90%]">
            <button
              className="absolute top-3 right-3 bg-white text-blue-700 px-3 py-1 rounded-full font-bold shadow-md"
              onClick={() => setSelectedImage(null)}
            >
              X
            </button>
            <Image
              src={selectedImage}
              alt="Imagem ampliada"
              width={1000}
              height={700}
              className="object-contain w-auto h-auto max-h-[90vh] rounded-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
}
